import React from "react";
import Newsletter_46 from "../component/Newsletter_46";

function Newsletter_46_container() {
  return <Newsletter_46 />;
}

export default Newsletter_46_container;
